import React, { Fragment, Suspense } from "react";
import AppLoading from "./AppLoading";
import { Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { ImportComponent } from "../../widgets/import_com/ImportComponent";

// Flattens menu -> submenu -> subsubmenu -> route into one list of routes.
// Doing this once with flatMap (instead of three nested .map calls returning
// arrays-of-arrays-of-arrays straight into JSX) makes it possible to give
// each <Route> a real, unique `key`, which React requires for list
// rendering and the original triple-.map version couldn't provide.
const flattenRoutes = (menuList) => {
  if (!Array.isArray(menuList)) return [];

  return menuList.flatMap((submenu) =>
    Array.isArray(submenu?.submenus)
      ? submenu.submenus.flatMap((subsubmenu) =>
          Array.isArray(subsubmenu?.subsubmenus) ? subsubmenu.subsubmenus : []
        )
      : []
  );
};

const MainContent = ({ setIconsButton }) => {
  const { menu_list } = useSelector((state) => state?.software);
  const routes = flattenRoutes(menu_list?.data);

  return (
    <Fragment>
      <Suspense fallback={<AppLoading />}>
        <Routes>
          {routes.map((route) => {
            const ComponentData = route?.component
              ? ImportComponent(route.component)
              : null;

            if (!ComponentData) return null;

            return (
              <Route
                key={route?.link ?? route?.component}
                path={route?.link}
                element={
                  <ComponentData
                    setIconsButton={setIconsButton}
                    PageTitle={route?.title}
                  />
                }
              />
            );
          })}
        </Routes>
      </Suspense>
    </Fragment>
  );
};

export default React.memo(MainContent);